import api from "../../../services/api";

export const getWholesaleRevenueOverTime = async () => {
  const { data } = await api.get("/api/wholesale/sales_reports/sales_over_time");
  return data;
};

export const getWholesaleOrdersOverTime = async () => {
  const { data } = await api.get("/api/wholesale/sales_reports/orders_over_time");
  return data;
};

export const getWholesaleUnitsOverTime = async () => {
  const { data } = await api.get("/api/wholesale/sales_reports/units_sold_over_time");
  return data;
};
